// Backend timestamps are UTC but often arrive WITHOUT a zone marker
// (e.g. "2026-09-01T00:07:18.173000"). JS parses zone-less strings as LOCAL
// time, causing a 5-hour offset. asUTC() marks them UTC before parsing so any
// { timeZone: 'America/Chicago' } render converts correctly. Idempotent: strings
// that already carry Z or an offset are left untouched.
export const asUTC = (s) => {
    if (!s) return null;
    if (typeof s === 'number') return new Date(s);
    const str = String(s);
    const hasTz = /(Z|[+-]\d{2}:?\d{2})$/.test(str);
    return new Date(hasTz ? str : str + 'Z');
};

export const CT = 'America/Chicago';
